export const ToastMessageType = {
  SUCCESS: "success",
  WARNING: "warning",
};
